import {
    AnyAction,
    CaseReducer,
    createAsyncThunk,
} from '@reduxjs/toolkit'
import {
    NinchatActionType,
    NinchatDescribeRealmAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {NinchatRealmFoundEvent} from 'api/types/events'
import {NinchatState} from 'api/types'
import {NinchatStoreRealm} from 'api/types/store'

const actionTypePrefix = 'NINCHAT/action'

type DescribeRealmAsyncThunkConfig = {
    pendingMeta: {reducer: CaseReducer<NinchatState, DescribeRealmPendingAction>}
    rejectedMeta: {reducer: CaseReducer<NinchatState, DescribeRealmRejectedAction>}
}

type DescribeRealmPendingAction = AnyAction & {meta: {arg: NinchatActionParams<NinchatDescribeRealmAction>}}
type DescribeRealmRejectedAction = AnyAction & {meta: {arg: NinchatActionParams<NinchatDescribeRealmAction>}}

export const describeRealm = createAsyncThunk<NinchatRealmFoundEvent, NinchatActionParams<NinchatDescribeRealmAction>, DescribeRealmAsyncThunkConfig>(
    `${actionTypePrefix}/${NinchatActionType.NinchatDescribeRealmAction}`,
    async (arg, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatDescribeRealmAction

        try {
            return await ninchatClient.send(params) as NinchatRealmFoundEvent
        } catch (err) {
            return rejectWithValue(err, {reducer: rejectedDescribeRealmReducer}) // eslint-disable-line @typescript-eslint/no-use-before-define
        }
    },
    {getPendingMeta: () => ({reducer: pendingDescribeRealmReducer})}, // eslint-disable-line @typescript-eslint/no-use-before-define
)

const pendingDescribeRealmReducer: CaseReducer<NinchatState, DescribeRealmPendingAction> = (state, action) => {
    const {arg: {realm_id}} = action.meta

    const realm = state.user_realms[realm_id] ?? ((state._realms ??= {})[realm_id] ??= {} as NinchatStoreRealm)

    realm._describe = 'pending'
}

const rejectedDescribeRealmReducer: CaseReducer<NinchatState, DescribeRealmRejectedAction> = (state, action) => {
    const {arg: {realm_id}} = action.meta

    const realm = state.user_realms[realm_id] ?? ((state._realms ??= {})[realm_id] ??= {} as NinchatStoreRealm)

    realm._describe = 'rejected'
}
